export const SITE = {
  name: "TRIPLE O",
  descriptor: "CREATIVE INDUSTRIES",
  email: "hello@tripleoci.com",
  phone: "(657) 514-4205",
  phoneHref: "tel:+16575144205",
  address1: "12038 Centralia St, Unit E",
  address2: "Hawaiian Gardens, CA 90716",
  location: "Hawaiian Gardens, California",
  markets: "ORANGE COUNTY · LOS ANGELES COUNTY · SURROUNDING COUNTIES",
  travel: "We travel anywhere — U.S. & international",
};

export const SHOW_FEED = false; // flip to true when Meta developer access is sorted

export const mailto = (subject) =>
  `mailto:${SITE.email}?subject=${encodeURIComponent(subject)}`;
